/**
 * ZenRentFlow Theme Palettes
 * 
 * Defines color palettes for the application theme system
 */

export const palettes = [
  {
    id: 'zenrentflow-original',
    name: 'ZenRentFlow Original',
    description: 'Soft, calming palette from the original logo',
    colors: {
      primary: '#94E3E3',
      secondary: '#D3C9CB',
      accent: '#F4AEB2',
      background: '#FFFFFF',
      surface: '#F8F9FA',
      text: {
        primary: '#2F303E',
        secondary: '#6B7280',
        muted: '#9CA3AF',
      },
      border: '#E5E7EB',
      success: '#7FB069',
      error: '#EF4444',
      warning: '#F59E0B',
      info: '#94E3E3',
    },
  },
  {
    id: 'zen-teal',
    name: 'Zen Teal',
    description: 'Deep teal and blue-green for trust and efficiency',
    colors: {
      primary: '#0D9488',
      secondary: '#14B8A6',
      accent: '#2DD4BF',
      background: '#FFFFFF',
      surface: '#F0FDFA',
      text: {
        primary: '#0F172A',
        secondary: '#475569',
        muted: '#64748B',
      },
      border: '#E2E8F0',
      success: '#10B981',
      error: '#EF4444',
      warning: '#F59E0B',
      info: '#0D9488',
    },
  },
  {
    id: 'soft-navy-sand',
    name: 'Soft Navy & Sand',
    description: 'Muted navy with sand neutrals',
    colors: {
      primary: '#1E3A8A',
      secondary: '#3B82F6',
      accent: '#F59E0B',
      background: '#FFFFFF',
      surface: '#FEF3C7',
      text: {
        primary: '#1E293B',
        secondary: '#475569',
        muted: '#64748B',
      },
      border: '#E2E8F0',
      success: '#10B981',
      error: '#EF4444',
      warning: '#F59E0B',
      info: '#3B82F6',
    },
  },
  {
    id: 'sage-slate',
    name: 'Sage & Slate',
    description: 'Desaturated sage green for balance',
    colors: {
      primary: '#7FB069',
      secondary: '#9B8FB8',
      accent: '#FF8C7F',
      background: '#FFFFFF',
      surface: '#F5F5F4',
      text: {
        primary: '#1C1917',
        secondary: '#57534E',
        muted: '#78716C',
      },
      border: '#D6D3D1',
      success: '#7FB069',
      error: '#EF4444',
      warning: '#F59E0B',
      info: '#7FB069',
    },
  },
  {
    id: 'warm-sage-lavender',
    name: 'Warm Sage & Lavender',
    description: 'Recommended rebranding palette - soft sage green with warm lavender',
    colors: {
      primary: '#7FB069',
      secondary: '#9B8FB8',
      accent: '#FF8C7F',
      background: '#FFFFFF',
      surface: '#FAFAF9',
      text: {
        primary: '#1C1917',
        secondary: '#6B6B6B',
        muted: '#9CA3AF',
      },
      border: '#E5E7EB',
      success: '#7FB069',
      error: '#EF4444',
      warning: '#F59E0B',
      info: '#7FB069',
    },
  },
  {
    id: 'calm-mint',
    name: 'Calm Mint',
    description: 'Fresh mint green for a calming, professional feel',
    colors: {
      primary: '#10B981',
      secondary: '#34D399',
      accent: '#6EE7B7',
      background: '#FFFFFF',
      surface: '#F0FDF4',
      text: {
        primary: '#064E3B',
        secondary: '#047857',
        muted: '#6B7280',
      },
      border: '#D1FAE5',
      success: '#10B981',
      error: '#EF4444',
      warning: '#F59E0B',
      info: '#10B981',
    },
  },
  {
    id: 'warm-cream',
    name: 'Warm Cream',
    description: 'Soft cream and warm beige for a cozy, approachable feel',
    colors: {
      primary: '#D97706',
      secondary: '#F59E0B',
      accent: '#FCD34D',
      background: '#FFFBEB',
      surface: '#FEF3C7',
      text: {
        primary: '#78350F',
        secondary: '#92400E',
        muted: '#78716C',
      },
      border: '#FDE68A',
      success: '#10B981',
      error: '#EF4444',
      warning: '#F59E0B',
      info: '#D97706',
    },
  },
  {
    id: 'ocean-breeze',
    name: 'Ocean Breeze',
    description: 'Cool ocean blues and teals for a fresh, professional look',
    colors: {
      primary: '#0891B2',
      secondary: '#06B6D4',
      accent: '#22D3EE',
      background: '#FFFFFF',
      surface: '#F0F9FF',
      text: {
        primary: '#0C4A6E',
        secondary: '#075985',
        muted: '#64748B',
      },
      border: '#BAE6FD',
      success: '#10B981',
      error: '#EF4444',
      warning: '#F59E0B',
      info: '#0891B2',
    },
  },
];






